"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeExcelEngine = void 0;
const hyperformula_1 = require("hyperformula");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const adapter_1 = require("../NodeEngine/adapter");
const utils = __importStar(require("../utils"));
const config_1 = require("./config");
const initializeExcelEngine = (initialInput) => {
    const f1Engine = adapter_1.f1EngineAdapters.excelEngine(initialInput);
    if (initialInput.f1EngineMode === 'use') {
        return f1Engine;
    }
    const _DEFAULT_SHEET_ID = 0;
    const _DEFAULT_SHEET_NAME = 'Sheet1';
    const _INCREMENTAL_ROW_BUFFER = 100;
    let _hfInstance;
    const _addEngineExpression = (key, value) => {
        const canAddOrChangeExpression = _hfInstance.isItPossibleToAddNamedExpression(key, value) ||
            _hfInstance.isItPossibleToChangeNamedExpression(key, value);
        (0, common_1.finleyAssert)(canAddOrChangeExpression, `Unable to set variable per HyperFormula for [key:${key}] [value:${value}]`);
        if (_hfInstance.getNamedExpression(key) !== undefined) {
            _hfInstance.changeNamedExpression(key, value);
        }
        else {
            _hfInstance.addNamedExpression(key, value);
        }
    };
    const _DEFAULT_EXPRESSIONS = [
        { key: 'TRUE', value: '=TRUE()' },
        { key: 'FALSE', value: '=FALSE()' },
    ];
    const _setupDefaultExpressions = () => {
        for (const { key, value } of _DEFAULT_EXPRESSIONS) {
            _addEngineExpression(key, value);
        }
    };
    const _generateColumnRangeVariable = (idx) => {
        const columnLetter = common_1.utils.numberToExcelLetter(idx);
        const columnRange = `=${_DEFAULT_SHEET_NAME}!$${columnLetter}:$${columnLetter}`;
        return columnRange;
    };
    const _setHeaderRangeVariables = (headers) => {
        headers.forEach((headerName, idx) => {
            const rangeName = utils.createRangeVariable(headerName);
            const rangeVariable = _generateColumnRangeVariable(idx);
            _addEngineExpression(rangeName, rangeVariable);
        });
    };
    // **************************************************************************************
    // Commenting out since no current use case for needing to convert data references to cell address
    // Related to: https://github.com/finleytechnologies/atlas/pull/5735
    // **************************************************************************************
    //
    // // Used during engine initialization to format special formula variables with associated cell references using header position
    // const _replaceVariablesWithCellReferences = (
    //   headers: string[],
    //   rowNumber: number,
    //   data: ExcelDataType,
    // ): ExcelDataType => {
    //   // Convert to string and check for formula (string beginning with '=')
    //   if (typeof data !== 'string') {
    //     return data;
    //   }
    //   // Return original data if not identified as formula
    //   if (!data.startsWith('=')) return data;
    //   // Continue, find variables for replacement
    //   const { nonRangeVariables } = getFormulaComposition(data);
    //   // Replace variables with associated cell reference using headers and row number provided.
    //   return nonRangeVariables.reduce<string>((updatedFormula, variable) => {
    //     const columnIndex = headers.indexOf(variable);
    //     finleyAssert(
    //       columnIndex !== -1,
    //       `ExcelEngine received formula referencing variable (${variable}) that is not available in headers`,
    //     );
    //     const columnLetter = utils.numberToExcelLetter(columnIndex);
    //     // Replace non-range variables using word boundary regex
    //     return updatedFormula.replace(
    //       new RegExp(`${variable}\\b`, 'g'),
    //       `${columnLetter}${rowNumber}`,
    //     );
    //   }, data);
    // };
    const _getFormulasCompositions = (formulas) => {
        const uniqueNonRangeVariables = new Set();
        const uniqueRangeVariables = new Set();
        for (const formula of formulas) {
            const { nonRangeVariables, rangeVariables } = utils.getFormulaComposition(formula);
            for (const nonRangeVariable of nonRangeVariables) {
                uniqueNonRangeVariables.add(nonRangeVariable);
            }
            for (const rangeVariable of rangeVariables) {
                uniqueRangeVariables.add(rangeVariable);
            }
        }
        return { uniqueNonRangeVariables, uniqueRangeVariables };
    };
    // Even though only managing one other logic flow, separating this function to easily
    // extend and customize when additional organization is needed
    const _flattenRowData = (singleData) => {
        const organizedData = common_1.utils.generateFlattenNestedKeyObject(singleData, { manageArrayValue: 'ignore' });
        return organizedData;
    };
    const _extractLoanTapeHeadersAndData = (data) => {
        if (data.length === 0) {
            return { headers: [], excelData: [] };
        }
        // Manage Headers: currently only care about headers and fields that are used
        // as part of ranged variables, as these are fields required across all receivables.
        // Non-ranged variables will be passed in and set at time of actual formula evaluation
        // so those data points aren't needed for the initial core data set (saving memory)
        const { uniqueRangeVariables } = _getFormulasCompositions(initialInput.formulas);
        const headers = [];
        for (const header of uniqueRangeVariables) {
            headers.push(utils.extractVariableNameFromRange(header));
        }
        // Sorting headers for easier debugging experience when needed. Headers will likely not be long
        // so not a true performance drag here
        headers.sort();
        // Manage 2D Excel Data (without headers): same order as headers (sorted)
        const excelData = [];
        for (const row of data) {
            const flattenedRowObject = _flattenRowData(row);
            // Since always basing on order of "headers", this ensures each row is in the
            // same column position as all other rows. This is particularly critical when
            // utilizing "range" variables so we ensure we reference same column
            const rowData = headers.reduce((outputRow, headerName) => {
                (0, common_1.finleyAssert)(headerName in flattenedRowObject, `ExcelEngine: inconsistent receivable keys when checking headers [key:${headerName}]`);
                outputRow.push(flattenedRowObject[headerName]);
                return outputRow;
            }, []);
            excelData.push(rowData);
        }
        return { headers, excelData };
    };
    const setVariables = (variableInput) => {
        if (initialInput.f1EngineMode) {
            try {
                f1Engine.setVariables(variableInput);
            }
            catch {
                // no-op
            }
        }
        const variableNames = [];
        const organizedData = _flattenRowData(variableInput);
        _hfInstance.suspendEvaluation();
        for (const [key, value] of Object.entries(organizedData)) {
            _addEngineExpression(key, value);
            variableNames.push(key);
        }
        _hfInstance.resumeEvaluation();
        return variableNames;
    };
    const clearVariables = (variables) => {
        for (const variableName of variables) {
            if (_hfInstance.isItPossibleToRemoveNamedExpression(variableName)) {
                _hfInstance.removeNamedExpression(variableName);
            }
        }
    };
    const clearSheet = () => {
        if (_hfInstance.isItPossibleToClearSheet(_DEFAULT_SHEET_ID)) {
            _hfInstance.clearSheet(_DEFAULT_SHEET_ID);
        }
    };
    const _evaluate = (formula) => {
        (0, common_1.finleyAssert)(formula, 'Received empty formula when trying to evaluate');
        // At time of engine initialization, formulas are expected to be pre-formatted
        // For one-off evaluation, currently expecting client to provide formula without "=" prepended
        (0, common_1.finleyAssert)(formula[0] !== '=', 'Received invalid formula that starts with =');
        const updatedFormula = `=${formula}`;
        const formulaResult = _hfInstance.calculateFormula(updatedFormula, _DEFAULT_SHEET_ID);
        if (formulaResult instanceof hyperformula_1.DetailedCellError) {
            (0, common_1.debugLog)(`Error while calculating Excel Engine formula for [formula:${updatedFormula}]`, formulaResult);
            throw new common_1.error.FinleyError(`Incurred error while calculating excel formula [formula:${updatedFormula}] [message:${formulaResult.message}]`, {
                logLevel: finley_types_1.Log.LogLevel.Error,
                metadata: {
                    logMeta: {
                        error: formulaResult,
                    },
                },
            });
        }
        if (initialInput.f1EngineMode === 'compareOnly') {
            f1Engine.compare(formula, formulaResult);
        }
        return formulaResult;
    };
    const evaluateNumber = (formula) => {
        const result = _evaluate(formula);
        (0, common_1.finleyAssert)(typeof result === 'number', new common_1.error.FinleyError('Failed to evaluate formula to expected number type', {
            metadata: {
                logMeta: {
                    formula,
                    result,
                    typeof: typeof result,
                },
            },
        }));
        return result;
    };
    const evaluateFullDateStr = (formula) => {
        const result = _evaluate(formula);
        (0, common_1.finleyAssert)(common_1.typeguards.isFullDateStr(result), new common_1.error.FinleyError('Failed to evaluate formula to expected fullDateStr type', {
            metadata: {
                logMeta: {
                    formula,
                    result,
                    typeof: typeof result,
                },
            },
        }));
        return result;
    };
    const evaluateBoolean = (formula) => {
        const result = _evaluate(formula);
        (0, common_1.finleyAssert)(typeof result === 'boolean', new common_1.error.FinleyError('Failed to evaluate formula to expected boolean type', {
            metadata: {
                logMeta: {
                    formula,
                    result,
                    typeof: typeof result,
                },
            },
        }));
        return result;
    };
    // ***** Initialize *****
    const _init = (data) => {
        const { headers, excelData } = _extractLoanTapeHeadersAndData(data);
        // As our data samples get larger (i.e., longer loan tapes), will need to monitor
        // and react accordingly with how we manage our data sizing and max constraints
        _hfInstance = hyperformula_1.HyperFormula.buildFromArray(excelData, {
            ...config_1.baseConfig,
            maxRows: data.length + _INCREMENTAL_ROW_BUFFER,
            maxColumns: 1000,
        });
        _setHeaderRangeVariables(headers);
        _setupDefaultExpressions();
    };
    _init(initialInput.data);
    // ***** Public Interface *****
    return {
        setVariables,
        clearVariables,
        clearSheet,
        evaluateNumber,
        evaluateFullDateStr,
        evaluateBoolean,
    };
};
exports.initializeExcelEngine = initializeExcelEngine;
//# sourceMappingURL=excelEngine.js.map